import { Reveal } from "./Reveal";
import { ShieldCheck, ArrowRight } from "lucide-react";

const CHECKS = [
  "Employer verification",
  "Recruitment partner verification",
  "Job-offer verification",
  "Contract / document review",
  "Candidate identity & qualification checks",
  "Recruitment-process risk assessment",
];

export const DueDiligence = () => (
  <section
    id="due-diligence"
    data-testid="due-diligence-section"
    className="py-24 md:py-32 px-6 md:px-12 bg-[#0a0a0a] text-white"
  >
    <div className="max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
      <Reveal>
        <div className="flex items-center gap-3 mb-8">
          <ShieldCheck size={26} className="text-[#ff3b30]" />
          <span className="font-body text-sm tracking-[0.25em] uppercase text-[#ff3b30]">
            Due diligence &amp; verification
          </span>
        </div>
        <h2 className="font-head uppercase tracking-tighter leading-[0.92] text-4xl md:text-6xl mb-8">
          Recruitment should
          <br />
          begin with
          <span className="font-accent italic lowercase text-[#ff3b30] normal-case tracking-normal">
            {" "}verification.
          </span>
        </h2>
        <p className="font-body text-[#a1a1aa] leading-relaxed max-w-md text-lg">
          Before anyone travels or signs, we verify. It's the core of how Daab protects both
          employers and candidates from recruitment risk and fraud.
        </p>
        <a
          href="/due-diligence"
          data-testid="due-diligence-cta"
          className="group mt-10 inline-flex items-center gap-3 bg-[#ff3b30] hover:bg-[#ff5248] text-white font-head uppercase text-sm tracking-wide px-8 py-4 w-max transition-colors duration-300"
        >
          Request due diligence
          <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
        </a>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="border-t border-[#27272a]">
          {CHECKS.map((c, i) => (
            <div
              key={c}
              data-testid={`diligence-${i}`}
              className="flex items-center gap-5 py-5 border-b border-[#27272a]"
            >
              <span className="font-head text-2xl text-[#52525b] w-10 shrink-0">0{i + 1}</span>
              <span className="font-body text-lg text-white">{c}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
